(() => {
  const moduleName = 'thankspage';

  TrackApp[moduleName] = (() => {
    const trackThanksPage = () => {
      if (!TrackApp.isTrackingDisabled()) {
        const { transaction, VAT, info = {} } = window.ua;
        window.dataLayer.push({
          event: 'Purchase',
          products: TrackApp.fillProductsFields(info),
          customerHash: transaction.analyticsUserHashedEmail,
          transaction: {
            id: transaction.transactionId,
            isFirstPrint: transaction.isFirstPrint,
            revenue: Math.round((transaction.totalCosts / VAT) * 100) / 100,
            totalRevenue: transaction.totalCosts,
            tax: Math.round((transaction.totalCosts - (transaction.totalCosts / VAT)) * 100) / 100,
            shipping: Math.round((transaction.freight / VAT) * 100) / 100,
            campaign: window.orderInfo ? window.orderInfo.campaign : 'N/A',
            payment: transaction.paymentMethod,
            shippingMethod: transaction.shippingMethod,
          },
        });
      }
      return TrackApp.mockTrackingApp;
    };

    return trackThanksPage;
  })();
})();
